import { UserConfigModel } from './Types';

export default (userConfig: Record<string, any>): UserConfigModel => {
  const {
    sacOnboard = 'default',
    isRentGuaranteeEnabled = false,
    landlordBirthDayMax = 0,
    landlordBirthDayMin = 0,
  } = userConfig;
  return {
    sacOnboard: sacOnboard && String(sacOnboard),
    isRentGuaranteeEnabled,
    landlordBirthDayMax,
    landlordBirthDayMin,
  };
};
